import { render, staticRenderFns } from "./CopyOfferDialog.vue?vue&type=template&id=5664d3bd&"
import script from "./CopyOfferDialog.vue?vue&type=script&lang=js&"
export * from "./CopyOfferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports